<template>
  <!-- 在线月度分析报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <el-button class="export" type="primary" size="small">生成PDF</el-button>
    <div class="analysisReport_box" id="pdfPrint">
      <div class="header_titles" style="margin-top:20px">
        <h1>国家职业教育智慧教育平台专业与课程服务中心</h1>
        <h1 style="margin:15px 0px;">（在线精品课和视频公开课）</h1>
        <h1>2022年第3季度运行数据分析报告</h1>
        <div class="number_time">
          <div>
            <span></span>
            <span>统计时间：2022-07-01至2022-09-30</span>
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <!-- 1.监测总览 -->
      <div class="chart_box">
        <h1>1. 监测总览</h1>
        <p>
          自2022年3月28日开始，国家职业教育智慧教育平台专业与课程服务中心上线，专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对在线开放课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>
          截至2022年6月30日，监测平台共接入在线精品课{{courseTotal.onlineBoutique}}门，视频公开课{{courseTotal.openVedio}}门，覆盖平台数有{{Platform.total.value}}个。
          在线精品课和视频公开课累计用户访问量达{{BoutiAndque.totalVisitNum.value}}；参与建设的院校有{{BoutiAndque.schoolNum.value}}所，教师{{BoutiAndque.tearchNum.value}}名。
        </p>

        <div style="height: 40px;"></div>

        <div class="chart_box">
          <h2>1.1 总体建设及应用分析</h2>

          <div class="chart_box">
            <h3>1.1.1. 课程建设情况</h3>

            <div class="chart_box">
              <p>截至2022年6月30日，课程总计{{ courseType.onlineQualitr.value + courseType.videOpen.value }}门，在线精品课{{courseType.onlineQualitr.value}}门，视频公开课{{courseType.videOpen.value}}门，其占比分布如下图所示：</p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='courseType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 1 课程来源分布</div>
            </div>

            <div class="chart_box">
              <p>截至2022年9月30日，参与课程建设的省份有34个，其中建设课程数最多的是{{courseRankTable.Max.province}}省，共{{courseRankTable.Max.total}}门。具体各省份参与课程建设数量排名（前十名）下如表所示：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>在线精品课数（门）</th>
                    <th>视频公开课数（门）</th>
                    <th>课程总数（门）</th>
                  </tr>

                  <tr v-for="(item,index) in courseRankTable.dataList" :key="index" v-show="courseRankTable.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.province}}</td>
                    <td>{{item.online}}</td>
                    <td>{{item.open}}</td>
                    <td>{{item.total}}</td>
                  </tr>
                  <tr v-show="courseRankTable.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 1 具体各省份参与课程建设数量排名（前十名）</div>
            </div>
            <div style="height: 30px;"></div>
            <div class="chart_box">
              <p>截至2022年6月30日，参与课程建设的教师累计{{BoutiAndque.tearchNum.value}}名，主要分布在{{courseNum.Frist.name}}省，其次在{{courseNum.Second.name}}省。具体各省份参与课程建设教师数量排名（前十名）如下表所示：</p>
              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'coursesOfferedChart'" :datas='courseNum.dataList' :transverseData='courseNum.transverseData' :colorList='courseNum.colorList'></tcolumnarChart>
              </div>
              <div class="chart_name">图 2 各省份参与课程建设教师数量排名（前十名）</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>1.1.2. 课程访问情况</h3>
            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，总访问量为{{BoutiAndque.totalVisitNum.value}}次，其中在线精品课{{onlineBoutique.totalVisitNum.value}}次，视频公开课{{vediOpen.totalVisitNum.value}}次。在线精品课《{{courseRankall.Max.courseName}}》的访问量最多，共{{courseRankall.Max.courseTotalVisit}}次。具体课程访问量排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程名称</th>
                    <th>课程来源</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>访问量</th>
                  </tr>

                  <tr v-for="(item,index) in courseRankall.dataList" :key="index" v-show="courseRankall.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.courseName}}</td>
                    <td>{{item.courseType}}</td>
                    <td>{{item.majorTeacher}}</td>
                    <td>{{item.schoolName}}</td>
                    <td>{{item.courseTotalVisit}}</td>
                  </tr>
                  <tr v-show="courseRankall.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 2 课程访问量排名（前十名）</div>
            </div>

            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，参与课程建设的省份有34个，其中{{provinceVisitRank.Max.province}}省的课程访问量最多。具体各省份的课程访问量排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>在线精品课访问量（次）</th>
                    <th>视频公开课访问量（次）</th>
                    <th>课程总访问量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in provinceVisitRank.dataList" :key="index" v-show="provinceVisitRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.province}}</td>
                    <td>{{item.total1}}</td>
                    <td>{{item.total2}}</td>
                    <td>{{item.total}}</td>
                  </tr>
                  <tr v-show="provinceVisitRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 3 各省课程访问量排名（前十名）</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>1.1.3. 课程选课情况</h3>
            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，选课人数总计{{BoutiAndque.selectedCourses.value}}人，在线精品课{{onlineBoutique.selectedCourses.value}}人，视频公开课{{vediOpen.selectedCourses.value}}人。其中在线精品课《{{courseStudyRank.Max.courseName}}》的选课人数最多，共{{courseStudyRank.Max.studyNum}}人。具体课程选课人数排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程名称</th>
                    <th>课程来源</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>选课人数（人）</th>
                  </tr>

                  <tr v-for="(item,index) in courseStudyRank.dataList" :key="index" v-show="courseStudyRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.courseName}}</td>
                    <td>{{item.courseType}}</td>
                    <td>{{item.majorTeacher}}</td>
                    <td>{{item.schoolName}}}</td>
                    <td>{{parseInt(item.studyNum)}}</td>
                  </tr>
                  <tr v-show="courseStudyRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 4 课程选课人数排名（前十名）</div>
            </div>

            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，参与课程建设的省份有34个，其中{{provinceStudyRank.Max.province}}省的课程选课人数最多，共{{provinceStudyRank.Max.total}}人。具体各省份课程选课人数排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>在线精品课选课人数（人）</th>
                    <th>视频公开课选课人数（人）</th>
                    <th>总选课人数（人）</th>
                  </tr>

                  <tr v-for="(item,index) in provinceStudyRank.dataList" :key="index" v-show="provinceStudyRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.province}}</td>
                    <td>{{item.total1}}</td>
                    <td>{{item.total2}}</td>
                    <td>{{item.total}}</td>
                  </tr>
                  <tr v-show="provinceStudyRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 5 各省课程访问量排名（前十名）</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>1.1.4. 课程互动情况</h3>
            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，课程互动总计{{BoutiAndque.interactionsTotal.value}}次，在线精品课{{onlineBoutique.interactionsTotal.value}}次，视频公开课***次，在线精品课《{{courseSemesterRank.Max.courseName}}》的互动次数最多，共{{courseSemesterRank.Max.sumInteractNum}}次。具体课程互动数排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程名称</th>
                    <th>课程来源</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>互动数（次）</th>
                  </tr>

                  <tr v-for="(item,index) in courseSemesterRank.dataList" :key="index" v-show="courseSemesterRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.courseName}}</td>
                    <td>{{item.courseType}}</td>
                    <td>{{item.majorTeacher}}</td>
                    <td>{{item.schoolName}}</td>
                    <td>{{parseInt(item.sumInteractNum)}}</td>
                  </tr>
                  <tr v-show="courseSemesterRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 6 课程互动数排名（前十名）</div>
            </div>

            <div class="chart_box">
              <div class="biaoge">
                <p>截至2022年6月30日，参与课程建设的省份有34个，其中{{provinceSemesterRank.Max.province}}省的课程访问量最多。共{{provinceSemesterRank.Max.total}}次，具体各省份的课程访问量排名（前十名）如下表所示：</p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>在线精品课互动数（次）</th>
                    <th>视频公开课互动数（次）</th>
                    <th>总互动数（次）</th>
                  </tr>

                  <tr v-for="(item,index) in provinceSemesterRank.dataList" :key="index" v-show="provinceSemesterRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.province}}</td>
                    <td>{{item.total1}}</td>
                    <td>{{item.total2}}</td>
                    <td>{{item.total}}</td>
                  </tr>
                  <tr v-show="provinceSemesterRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 7 各省课程互动数排名（前十名）</div>
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h2>1.2 2022-01-01至2022-06-30整体运行情况分析</h2>
          <div class="chart_box">
            <h3>1.2.3. 课程访问情况</h3>
            <div class="chart_box">
              <p>在分析时间内，课程新增访问量{{SelectVisitData.VisitTotal}}次，新增访问量趋势图如下所示：</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'typeDistributionChart'" :datas='SelectVisitData.dataList' :transverseData="SelectVisitData.transverseData" :colorList='SelectVisitData.colorList' :legendList='SelectVisitData.legendList' :isaverage="true" :innerText="'单位：次'">
                </discountChart>
              </div>
              <div class="chart_name">图 2 2022-07-01至2022-09-30 课程新增访问量趋势图</div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h1>2. 在线精品课应用分析</h1>
        <div class="chart_box">
          <h2>2.1. 在线精品课建设及应用情况</h2>
          <div class="chart_box">
            <p>
              依据监测平台统计，截止到2022年9月30日，在线精品课程共建{{courseTotal.onlineBoutique}}门，其中，国家级课程有{{ByLevel.FristArr.value}}门，省市级课程有{{ByLevel.SecArr.value}}门，校级课程有{{ByLevel.ThrArr.value}}门，
              共覆盖平台数{{Platform.total.value}}个。目前，在线精品课程已有{{onlineBoutique.schoolNum.value}}所院校和{{onlineBoutique.tearchNum.value}}名教师参与建设与应用；总访问量达{{onlineBoutique.totalVisitNum.value}}次，总开课期数为{{onlineBoutique.startsCourses.value}}期，总课时数为{{onlineBoutique.classHour.value}}小时，
              总选课人数{{onlineBoutique.selectedCourses.value}}人，总互动次数{{onlineBoutique.interactionsTotal.value}}次；具体建设与应用情况如下：
            </p>
          </div>

          <div class="chart_box">
            <h3>2.1.1. 在线精品课建设情况</h3>
            <div class="chart_box">
              <p>（1）各省参建课程数量排名</p>
              <div class="chart_box">
                <p>
                  截止到2022年9月30日，在线精品课课程总计{{courseTotal.onlineBoutique}}门，其中，{{getonlineCreateRank.province}}省参与建设课程数量最多，共{{getonlineCreateRank.Max.total}}门，具体各省参建课程数量排名（前十五名）如下表所示：
                </p>
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>排名</th>
                      <th>省份</th>
                      <th>参建课程总数</th>
                      <th>国家级课程数</th>
                    </tr>

                    <tr v-for="(item,index) in getonlineCreateRank.dataList" :key="index" v-show="getonlineCreateRank.dataList.length > 0">
                      <td>{{index+1}}</td>
                      <td>{{item.province}}</td>
                      <td>{{item.total}}</td>
                      <td>{{item.count}}</td>
                    </tr>
                    <tr v-show="getonlineCreateRank.dataList.length == 0" class="nothing">
                      <td colspan="4">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">表 4 各省参建在线精品课数量排名（前十名）</div>
              </div>
            </div>

            <div class="chart_box">
              <p>（2）建设课程数量专业大类分布</p>
              <p>截止到2022年9月30日，课程覆盖{{onlineCourseCategory.dataList.length}}个专业大类。从专业大类分布看，{{onlineCourseCategory.Max.name}}的课程最多，一共{{onlineCourseCategory.Max.value}}门课程，占比达{{((onlineCourseCategory.Max.value / onlineCourseCategory.total)*100).toFixed(2)}}%，具体分布如下图所示：</p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='onlineCourseCategory.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 1 在线精品课专业大类分布情况</div>
            </div>
          </div>

          <!-- 课程选课情况 -->
          <div class="chart_box">
            <h3>2.1.2. 在线精品课访问情况</h3>
            <div class="chart_box">
              <p>截止到2022年9月30日，在线精品课程共计访问量{{(onlineBoutique.totalVisitNum.value / 100000000).toFixed(2) +'亿'}}，访问量最高的课程是{{couseAll.MaxArr.schoolname}}的《{{couseAll.MaxArr.name}}》，访问量排名前（十五名）的课程信息如下：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>访问量</th>
                  </tr>

                  <tr v-for="(item,index) in couseAll.dataList" :key="index" v-show="couseAll.dataList.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.level}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="couseAll.dataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>

          <!-- 课程访问情况 -->
          <div class="chart_box">
            <h3>2.1.3. 在线精品课开课情况</h3>
            <div class="chart_box">
              <p>截止到2022年9月30日，在线精品课程共计开课期数{{onlineBoutique.startsCourses.value}}期，开课期数最多的课程是{{couseOpen.MaxArr.schoolname}}的《{{couseOpen.MaxArr.name}}》，开课期数前十五名的课程信息如下：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>开课期数</th>
                  </tr>

                  <tr v-for="(item,index) in couseOpen.dataList" :key="index" v-show="couseOpen.dataList.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.level}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="couseOpen.dataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">在线精品课开课期数排名（前十五名）</div>
            </div>
          </div>

          <!-- 课程互动情况 -->
          <div class="chart_box">
            <h3>2.1.4. 在线精品课程选课情况</h3>
            <div class="chart_box">
              <p>截止到2022年9月30日，在线精品课程共计选课人数{{onlineBoutique.selectedCourses.value}}人，选课人数最多的课程是{{courseSelect.MaxArr.schoolname}}的《{{courseSelect.MaxArr.name}}》，选课人数前十五名的课程信息如下：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>选课人数</th>
                  </tr>

                  <tr v-for="(item,index) in courseSelect.dataList" :key="index" v-show="courseSelect.dataList.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.level}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="courseSelect.dataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>

            </div>
            <div class="chart_name">在线精品课选课人数排名（前十五名）</div>
          </div>
        </div>
      </div>

      <!--<div class="chart_box">
        <h4>2.2. 2022-07-01至2022-09-30在线精品课运行情况分析</h4>
         <div class="chart_box">
          <p>2.2.1. 课程开课情况</p>
          <div class="chart_box">
            <p>
              该时间段，在线精品课累计开课期数为N期，具体开课情况如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='projectTop.dataList' :transverseData="projectTop.transverseData" :colorList='projectTop.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'90%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name"> 2022-07-01至2022-09-30 在线精品课开课期数趋势</div>
          </div>
        </div> -->

      <!-- <div class="chart_box">
          <p>2.2.2. 课程选课情况</p>
          <div class="chart_box">
            <p>
              该时间段，在线精品课累计选课人数为N人，具体选课情况如下图所示:
            </p>
            <div class="standards_content echartsHeight">
            </div>
            <div class="chart_name"> 2022-07-01至2022-09-30 在线精品课开课期数趋势</div>
          </div>
        </div> -->

      <!-- <div class="chart_box">
        <p>2.2.3. 课程访问情况</p>
        <p>在分析时间内，课程新增访问量N次，新增访问量趋势图如下所示：</p>
        <div class="standards_content echartsHeight">
          <discountChart :refId="'usersMonthChart'" :datas='usersMonth.dataList' :transverseData='usersMonth.transverseData' :colorList='usersMonth.colorList' :legendList="usersMonth.legendList" :innerText="'单位：人'"></discountChart>
          <div class="chart_name">图34 2022-07-01至2022-09-30 新增访问量数趋势图</div>
        </div>
      </div> -->

      <!--<div class="chart_box">
        <p>2.2.4. 课程互动情况</p>
        <p>该时间段，在线精品课课程累计互动次数N次，具体互动情况如下图所示。</p>
        <div class="standards_content echartsHeight">
           <discountChart :refId="'usersMonthChart'" :datas='usersMonth.dataList' :transverseData='usersMonth.transverseData' :colorList='usersMonth.colorList' :legendList="usersMonth.legendList" :innerText="'单位：人'"></discountChart>
          <div class="chart_name">图35 2022-07-01至2022-09-30 在线精品课课程互动趋势。</div>
        </div>
      </div>
    </div> -->

      <!-- 视频公开课应用分析  -->
      <div class="chart_box">
        <h1>3. 视频公开课应用分析</h1>
        <div class="chart_box">
          <h2>3.1. 视频公开课建设及应用情况</h2>
          <div class="chart_box">
            <p>
              依据监测平台统计，截止到2022年9月30日，视频公开课共建{{courseType.videOpen.value}}门，其中，课程思政示范课有{{vedioByLevel.FristArr.value}}门、国家规范教材有{{vedioByLevel.SecArr.value}}门、公共基础课有{{vedioByLevel.ThrArr.value}}门、教学能力比赛获奖作品有{{vedioByLevel.FouArr.value}}门，
              共覆盖平台数{{vedioPlatform.total.value}}个。目前，视频公开课已有{{vediOpen.schoolNum.value}}所院校和{{vediOpen.tearchNum.value}}名教师参与建设与应用；总访问量达{{vediOpen.totalVisitNum.value}}次，总开课期数为{{vediOpen.startsCourses.value}}期，总课时数为{{vediOpen.classHour.value}}小时，总选课人数{{vediOpen.selectedCourses.value}}人，。
              具体建设与应用情况如下：
            </p>
          </div>

          <!-- 课程建设情况 -->
          <div class="chart_box">
            <h3>3.1.1. 视频公开课建设情况</h3>
            <div class="chart_box">
              <p>（1）各省参建课程数量排名</p>
              <div class="chart_box">
                <p> 截止到2022年9月30日，视频公开课课程总计{{courseType.videOpen.value}}门，其中，{{courseTop.MaxArr.province}}省参与建设课程数量最多，共{{courseTop.MaxArr.total}}门，具体各省参建课程数量排名（前十名）如下表所示：</p>
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>排名</th>
                      <th>省份</th>
                      <th>参建课程数</th>
                      <th>选课人数</th>
                    </tr>

                    <tr v-for="(item,index) in courseTop.dataList" :key="index" v-show="courseTop.dataList.length > 0">
                      <td>{{ index + 1 }}</td>
                      <td>{{item.province}}</td>
                      <td>{{item.total}}</td>
                      <td>{{item.studynum}}</td>
                    </tr>
                    <tr v-show="courseTop.dataList.length == 0" class="nothing">
                      <td colspan="5">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">表 4 各省参建在线精品课数量排名（前十名）</div>
              </div>
            </div>

            <div class="chart_box">
              <p>（2）建设课程数量专业大类分布</p>
              <p>截止到2022年9月30日，课程覆盖{{vedioCourseCategory.dataList.length}}个专业大类。从专业大类分布看，{{vedioCourseCategory.Max.name}}的课程最多，一共{{vedioCourseCategory.Max.value}}门课程，占比达{{((vedioCourseCategory.Max.value / vedioCourseCategory.total)*100).toFixed(2)}}%，具体分布如下图所示：</p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='vedioCourseCategory.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 1 视频公开课专业大类分布情况</div>
            </div>
          </div>

          <!-- 课程选课情况 -->
          <div class="chart_box">
            <h3>3.1.2. 视频公开课访问情况</h3>
            <div class="chart_box">
              <p>截止到2022年9月30日，视频公开课共计访问量{{vediOpen.totalVisitNum.value}}，访问量最高的课程是{{courseVideoPen.MaxArr.schoolname}}的《{{courseVideoPen.MaxArr.name}}》，访问量排名前十名的课程信息如下：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>课程类型</th>
                    <th>访问量</th>
                  </tr>

                  <tr v-for="(item,index) in courseVideoPen.dataList" :key="index" v-show="courseVideoPen.dataList.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.platform}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="courseVideoPen.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">视频公开课访问量排名（前十名）</div>
            </div>
          </div>

          <!-- 课程访问情况 -->
          <div class="chart_box">
            <h3>3.1.3. 视频公开课选课情况</h3>
            <div class="chart_box">

              <div class="biaoge">
                <p>
                  截止到2022年6月30日，视频公开课共计选课人数{{vediOpen.selectedCourses.value}}人，选课人数最多的课程是{{courseVideoSel.MaxArr.schoolname}}的《{{courseVideoSel.MaxArr.name}}》，选课人数前（十五名）的课程信息如下：
                </p>
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>课程类型</th>
                    <th>选课人数</th>
                  </tr>

                  <tr v-for="(item,index) in courseVideoSel.dataList" :key="index" v-show="courseVideoSel.dataList.length > 0">
                    <td>{{ index + 1 }}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.courseclass}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="courseVideoSel.dataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">视频公开课选课人数排名（前十五名）</div>
            </div>
          </div>
        </div>

        <!-- <div class="chart_box">
          <h2>3.2. 2022-07-01至2022-09-30视频公开课运行情况分析</h2>
          <div class="chart_box">
            <h3>3.2.1. 课程访问情况</h3>
            <div class="chart_box">
              <p>
                该时间段，视频公开课累计选课人数N人，具体选课情况如下图所示：
              </p>
              图 1 用户类型分布(单位：人)
              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'typeDistributionChart'" :datas='projectTop.dataList' :transverseData="projectTop.transverseData" :colorList='projectTop.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
              </div>
              <div class="chart_name">2022-07-01至2022-09-30视频公开课访问趋势。</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

  </div>
  </div>
  </div>
</template>

<script>
import circularChart from '@/components/chart/circularChart.vue'; // 引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue'; // 引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'; // 引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue'; // 引入折线图图表
import waterDropChart from '@/components/chart/waterDropChart.vue'; // 引入水滴图图表
import distributionChart from '@/components/chart/distributionChart.vue'; // 地图

export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart
  },
  data() {
    return {
      year: '',
      yearAndMonthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'], // 柱状图或折线图的颜色
      color: ['#ffd9d9', '#ff0000', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],
      header: {
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: ''
      },

      loading: '', // 是否导出加载中
      // 查询精品课和公开课的数量
      courseTotal: {
        onlineBoutique: null,
        openVedio: null
      },
      BoutiAndque: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {},
        startsCourses: {},
        classHour: {},
        interactionsTotal: {},
        units: {},
        selectedCourses: {}
      },
      // 精品课数据
      onlineBoutique: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {},
        startsCourses: {},
        classHour: {},
        interactionsTotal: {},
        units: {},
        selectedCourses: {}
      },
      // 公开课数据
      vediOpen: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {}
      },
      // 视频公开课，在线精品课的数据总和
      vedioAopen: {
        tearchNumTotal: null,
        totalVisitNumTotal: null,
        schoolNumTotal: null
      },
      // 课程类型分布
      courseType: {
        dataList: [],
        courseTotal: null,
        onlineQualitr: null,
        videOpen: null
      },

      // 课程表格排名
      courseRankTable: {
        dataList: [],
        Max: {}
      },
      // 
      courseNum: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {}
      },
      // 课程总访问量
      courseRankall: {
        dataList: [],
        Max: {}
      },
      // 各省课程访问量
      provinceVisitRank: {
        dataList: [],
        Max: {}
      },
      // 课程选课情况
      courseStudyRank: {
        dataList: [],
        Max: {}
      },
      // 各省课程访问情况
      provinceStudyRank: {
        dataList: [],
        Max: {}
      },
      // 课程互动情况
      courseSemesterRank: {
        dataList: [],
        Max: {}
      },
      // 各省课程互动情况
      provinceSemesterRank: {
        dataList: [],
        Max: {}
      },



      // 区间内在线精品课程访问情况
      selectCourseOnlineVisit: {
        dataList: [],
        VisitTotal: null
      },
      // 区间内视频公开课访问情况
      selectCourseVediOpenVisit: {
        dataList: [],
        VisitTotal: null
      },

      // 区间内访问总数据
      SelectVisitData: {
        VisitTotal: null,
        dataList: [],
        legendList: [],
        colorList: [],
        transverseData: []
      },

      // 在线精品课 课程级别
      ByLevel: {
        dataList: [],
        total: null,
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {}
      },
      // 视频公开课 课程级别
      vedioByLevel: {
        dataList: [],
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {},
        FouArr: {}
      },
      // 在綫精品課平台数
      Platform: {
        total: null
      },
      // 视频公开课平台数
      vedioPlatform: {
        total: null
      },
      // 在线精品课课建设情况
      getonlineCreateRank: {
        dataList: [],
        Total: null,
        Max: {}
      },

      // 在线精品课专业课程大类分布
      onlineCourseCategory: {
        dataList: [],
        total: null,
        Max: {},
      },
      // 课程访问量排名
      couseAll: {
        dataList: [],
        MaxArr: [],
        total: null
      },
      // 课程开课期数
      couseOpen: {
        dataList: [],
        MaxArr: [],
        total: null
      },
      // 课程选课人次排名
      courseSelect: {
        dataList: [],
        MaxArr: {},
        total: null
      },
      // 视频公开课_参建课程数量排名
      courseTop: {
        dataList: [],
        MaxArr: [],
        total: null
      },
      // 视频公开课 专业大类
      vedioCourseCategory: {
        dataList: [],
        Max: [],
        total: null
      },

      // 视频公开课访问情况
      courseVideoPen: {
        dataList: [],
        MaxArr: [],
        total: null
      },
      // 视频选课
      courseVideoSel: {
        dataList: [],
        MaxArr: [],
        total: null
      },
    };
  },
  created() {
    if (this.$route.query) {
      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      const year = this.$route.query.yearOrMonth
      const monthly = this.$route.query.yearOrMonth
      // const year = this.$route.query.yearOrMonth.substring(0, 4);
      // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
      this.$route.query.startTime = `${year}-${monthly}-${1}`;
      this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header = this.$route.query;
      this.year = `${year}-${monthly}`;
      this.yearAndMonthly = this.$route.query.yearOrMonth;
      this.yearMonthText = `2022年上半年运行数据分析报告`;
    }

    this.getcourseReportTotal()                           //     获取在线精品课和视频公开课的数量
    this.getOnlineBoutiAndqueHandler()                    //     全部总览
    this.getOnlineBoutiqueHandler()                       //     在线精品课数据总览
    this.getVediOpenHandler()                             //     视频公开课数据总览


    this.courseTypeHandler()
    this.courseRankHandler()                              //    具体各省份参与课程建设数量排名（前十名）
    this.courseTearcherHandler()                          //    省份参与课程建设教师数量排名（前十名）
    this.courseRankallHandler()                           //    课程总访问量
    this.provinceVisitRankHandler()                       //    各省课程访问情况
    this.courseStudyRankHandler()                         //    课程选课情况
    this.provinceStudyRankHandler()                       //    各省选课人数

    this.courseSemesterRankHandler()                      //    课程互动情况排名
    this.provinceSemesterRankHandler()                    //    各省课程互动情况



    // 1.2  2022-07-01至2022-09-30整体运行情况
    this.selectCourseOnlineVisitHandler()                 //    区间内在线精课新增访问趋势
    this.selectCourseVediOpenVisitHandler()               //    区间内视频公开课新增访问趋势

    // 2. 在线精品课应用分析
    this.ByLevelHandler()                                 //    在线精品课课课程级别
    this.PlatformHandler()                                //    获取平台数
    this.getonlineCreateRankHandler()                     //    在线精品课课程建设情况

    this.onlineCourseCategoryHandler()                    //    在线精品课专业课程大类分布情况
    this.courseAlltalk()                                  //    课程访问量排名
    this.couseOpenHandler()                               //    课程开课期数
    this.courseSelection()                                //    课程选课人次排名


    this.vedioByLevelHandler()                            //    视频公开课课程级别
    this.vedioPlatformHandler()                           //    视频公开课平台数
    this.courseSelection()

    this.courseTopHandler()
    this.vedioCourseCategoryHandler()

    this.courseVideoPenHandler()
    this.courseVideoSelHandler()
  },

  methods: {
    // 查询精品课和公开课的数量
    getcourseReportTotal() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportTotal, {
        loading: false
      }).then((res) => {
        let value = Object.values(res.data)
        this.courseTotal.onlineBoutique = value[0]
        this.courseTotal.openVedio = value[1]
      })
    },

    // 数据总量
    getOnlineBoutiAndqueHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportOverview, 3, {
        loading: false
      }).then((res) => {
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        this.BoutiAndque.schoolNum = datas.find(item => item.name == '参建院校')
        this.BoutiAndque.tearchNum = datas.find(item => item.name == '教师参建人次')
        this.BoutiAndque.totalVisitNum = datas.find(item => item.name == '总访问量')
        this.BoutiAndque.startsCourses = datas.find(item => item.name == '总开课期数')
        this.BoutiAndque.classHour = datas.find(item => item.name == '总课时数')
        this.BoutiAndque.interactionsTotal = datas.find(item => item.name == '累计互动次数')
        this.BoutiAndque.units = datas.find(item => item.name == '学员所属单位数（个次）')
        this.BoutiAndque.selectedCourses = datas.find(item => item.name == '总选课人数')
      })
    },

    // 在线精品课数据总览
    getOnlineBoutiqueHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportOverview, 1, {
        loading: false
      }).then((res) => {
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        this.onlineBoutique.schoolNum = datas.find(item => item.name == '参建院校')
        this.onlineBoutique.tearchNum = datas.find(item => item.name == '教师参建人次')
        this.onlineBoutique.totalVisitNum = datas.find(item => item.name == '总访问量')
        this.onlineBoutique.startsCourses = datas.find(item => item.name == '总开课期数')
        this.onlineBoutique.classHour = datas.find(item => item.name == '总课时数')
        this.onlineBoutique.interactionsTotal = datas.find(item => item.name == '累计互动次数')
        this.onlineBoutique.units = datas.find(item => item.name == '学员所属单位数（个次）')
        this.onlineBoutique.selectedCourses = datas.find(item => item.name == '总选课人数')
      })
    },

    // 视频公开课数据总览
    getVediOpenHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportOverview, 2, {
        loading: false
      }).then((res) => {
        console.log(res.data);
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        this.vediOpen.schoolNum = datas.find(item => item.name == '参建院校')
        this.vediOpen.tearchNum = datas.find(item => item.name == '教师参建人次')
        this.vediOpen.totalVisitNum = datas.find(item => item.name == '总访问量')
        this.vediOpen.startsCourses = datas.find(item => item.name == '总开课期数')
        this.vediOpen.classHour = datas.find(item => item.name == '总课时数')
        this.vediOpen.interactionsTotal = datas.find(item => item.name == '累计互动次数')
        console.log(this.vediOpen.interactionsTotal);
        // 总互动次数{{vediOpen.interactionsTotal.value}}次
        this.vediOpen.units = datas.find(item => item.name == '学员所属单位数（个次）')
        this.vediOpen.selectedCourses = datas.find(item => item.name == '总选课人数')
      })
    },

    // 课程类型分布
    courseTypeHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getCountryReportOverview, {
        loading: false,
      }).then((res) => {

        this.courseType.dataList.push(
          {
            name: '在线精品课数',
            value: res.data.onlineCourseNum
          }, {
          name: '视频公开课',
          value: res.data.videoCourseNum
        })

        this.courseType.dataList.forEach(item => {
          this.courseType.courseTotal += item.value
        })
        this.courseType.courseAll = this.courseType.dataList.find(item => item.name == '资源库总数')
        this.courseType.onlineQualitr = this.courseType.dataList.find(item => item.name == '在线精品课数')
        this.courseType.videOpen = this.courseType.dataList.find(item => item.name == '视频公开课')
      })
    },

    // 表格形式的排名
    courseRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportProvinceRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.courseRankTable.dataList = res.data
          this.courseRankTable.Max = this.courseRankTable.dataList[0]
        }
      })
    },

    // 各省份参与课程建设教师数量排名（前十名）
    courseTearcherHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportTearcherRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          let datas = []
          for (let i = 0; i < res.data.value.length; i++) {
            this.courseNum.dataList.push(res.data.value[i])
            this.courseNum.transverseData.push(res.data.name[i])
            datas.push({ name: res.data.name[i], value: res.data.value[i] })
          }

          function Sort(a, b) {
            return b.value - a.value
          }
          this.courseNum.dataList.sort(Sort)
          this.courseNum.Frist = datas[0]
          this.courseNum.Second = datas[1]

          this.courseNum.colorList = this.colorList
        }
      })
    },
    // 课程总访问量排名
    courseRankallHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportVisitRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.courseRankall.dataList = res.data

          function Sort(a, b) {
            return b.courseTotalVisit - a.courseTotalVisit
          }
          this.courseRankall.dataList.sort(Sort)
          this.courseRankall.Max = this.courseRankall.dataList[0]
        }
      })
    },
    // 各省课程访问排名
    provinceVisitRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportProvinceVisitRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res) {
            this.provinceVisitRank.dataList = res.data
            this.provinceVisitRank.Max = this.provinceVisitRank.dataList[0]
          }
        }
      })
    },

    // 课程选课情况
    courseStudyRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportStudyRank, 3, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res) {
            this.courseStudyRank.dataList = res.data
            this.courseStudyRank.Max = this.courseStudyRank.dataList[0]
          }
        }
      })
    },

    // 各省选课情况排名
    provinceStudyRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportProvinceStudyRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res) {
            this.provinceStudyRank.dataList = res.data
            function Sort(a, b) {
              return b.courseTotalVisit - a.courseTotalVisit
            }
            this.provinceStudyRank.dataList.sort(Sort)
            this.provinceStudyRank.Max = this.provinceStudyRank.dataList[0]
          }
        }
      })
    },

    // 课程互动情况排名
    courseSemesterRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportSemesterRank, 3, {
        loading: false,
      }).then((res) => {
        this.courseSemesterRank.dataList = res.data
        this.courseSemesterRank.Max = this.courseSemesterRank.dataList[0]
      })
    },
    // 各省课程互动情况
    provinceSemesterRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportProvinceSemesterRank, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.provinceSemesterRank.dataList = res.data
          this.provinceSemesterRank.Max = this.provinceSemesterRank.dataList[0]
        }
      })
    },

    // 在线精品课区间内课程访问情况
    selectCourseOnlineVisitHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportRegionVisitsRank, { endDay: '2022-09-30', startDay: '2022-07-01', type: 1 }, {
        loading: false,
      }).then((res) => {
        this.selectCourseOnlineVisit.dataList = res.data.value
        this.selectCourseOnlineVisit.dataList.forEach(item => {
          this.selectCourseOnlineVisit.VisitTotal += item
        })

        // 总数据
        this.SelectVisitData.dataList.push(this.selectCourseOnlineVisit.dataList, this.selectCourseVediOpenVisit.dataList)
        this.SelectVisitData.transverseData = res.data.name
        this.SelectVisitData.legendList.push('在线精品课', '视频公开课')
        this.SelectVisitData.colorList = this.colorList
        this.SelectVisitData.VisitTotal = this.selectCourseOnlineVisit.VisitTotal + this.SelectVisitData.VisitTotal

        console.log(this.SelectVisitData);

      })
    },

    // 视频公开课区间内课程访问情况
    selectCourseVediOpenVisitHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportRegionVisitsRank, { endDay: '2022-09-30', startDay: '2022-07-01', type: 2 }, {
        loading: false,
      }).then((res) => {
        this.selectCourseVediOpenVisit.dataList = res.data.value
        this.selectCourseVediOpenVisit.dataList.forEach(item => {
          this.selectCourseVediOpenVisit.VisitTotal += item
        })
      })
    },


    // 在线精品课 课程级别
    ByLevelHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseCountByLevel, 1, {
        loading: false,
      }).then((res) => {
        for (let i = 0; i < res.data.value.length; i++) {
          this.ByLevel.dataList.push({ name: res.data.name[i], value: res.data.value[i] })
          this.ByLevel.total += res.data.value[i]
        }
        this.ByLevel.FristArr = this.ByLevel.dataList[0]
        this.ByLevel.SecArr = this.ByLevel.dataList[1]
        this.ByLevel.ThrArr = this.ByLevel.dataList[2]
      })
    },

    // 视频公开课 课程级别
    vedioByLevelHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseCountByLevel, 2, {
        loading: false,
      }).then((res) => {
        for (let i = 0; i < res.data.value.length; i++) {
          this.vedioByLevel.dataList.push({ name: res.data.name[i], value: res.data.value[i] })
          // this.vedioByLevel.total += res.data.value[i]
        }
        this.vedioByLevel.FristArr = this.vedioByLevel.dataList[0]
        this.vedioByLevel.SecArr = this.vedioByLevel.dataList[1]
        this.vedioByLevel.ThrArr = this.vedioByLevel.dataList[2]
        this.vedioByLevel.FouArr = this.vedioByLevel.dataList[3]
      })
    },

    // 在线精品课平台数
    PlatformHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 1, {
        loading: false,
      }).then((res) => {
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        this.Platform.total = datas.find(item => item.name == '平台数')
      })
    },

    // 视频公开课平台数
    vedioPlatformHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 2, {
        loading: false,
      }).then((res) => {
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        this.vedioPlatform.total = datas.find(item => item.name == '平台数')
      })
    },

    // 在线精品课建设情况
    getonlineCreateRankHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCourseReportProvinceCreateRank, 1, {
        loading: false,
      }).then((res) => {
        this.getonlineCreateRank.dataList = res.data
        this.getonlineCreateRank.dataList.forEach(item => {
          this.getonlineCreateRank.Total += item.total
        })
        this.getonlineCreateRank.Max = this.getonlineCreateRank.dataList[0]
      })
    },

    // 在线精品课专业课程大类分布情况
    onlineCourseCategoryHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCountryReportCourseCategoryBuild, 1, {
        loading: false,
      }).then((res) => {
        this.onlineCourseCategory.dataList = res.data

        function Sort(a, b) {
          return b.value - a.value
        }
        this.onlineCourseCategory.dataList.sort(Sort)
        this.onlineCourseCategory.Max = res.data[0]

        res.data.forEach(item => {
          this.onlineCourseCategory.total += item.value
        })
      })
    },

    // 课程总访问量排名
    courseAlltalk() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseVisitRank, { statType: 1, limitNum: 15 }, {
        loading: false,
      }).then((res) => {
        this.couseAll.dataList = res.data
        this.couseAll.MaxArr = this.couseAll.dataList[0]
        this.couseAll.dataList.forEach(item => {
          this.couseAll.total += item.num
        })
      })
    },

    // 课程开课期数
    couseOpenHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getCountryReportCourseSemesterRank, { statType: 1, limitNum: 15 }, {
        loading: false,
      }).then((res) => {

        this.couseOpen.dataList = res.data
        this.couseOpen.MaxArr = this.couseOpen.dataList[0]
        this.couseOpen.total = res.total

      })
    },
    // 课程选课人次排名
    courseSelection() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseStudyRank, { statType: 1, limitNum: 15 }, {
        loading: false,
      }).then((res) => {

        this.courseSelect.dataList = res.data
        this.courseSelect.MaxArr = this.courseSelect.dataList[0]
        this.courseSelect.dataList.forEach(item => {
          this.courseSelect.total += item.num
        })
      })
    },


    // 各省参建课程数量排名
    courseTopHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getCountryReportCourseProvinceRank, 2, {
        loading: false,
      }).then((res) => {
        this.courseTop.dataList = res.data.slice(0, 10)
        this.courseTop.MaxArr = this.courseTop.dataList[0]
        for (let i = 0; i < res.data.length; i++) {
          this.courseTop.total += res.data[i].studynum
        }
      })
    },

    // 视频公开课_课程专业大类分布
    vedioCourseCategoryHandler() {
      this.$axios.post(this.$apiurls.courseReport_getCountryReportCourseCategoryBuild, 2, {
        loading: false,
      }).then((res) => {
        this.vedioCourseCategory.dataList = res.data

        function Sort(a, b) {
          return b.value - a.value
        }
        this.vedioCourseCategory.dataList.sort(Sort)
        this.vedioCourseCategory.Max = res.data[0]

        res.data.forEach(item => {
          this.vedioCourseCategory.total += item.value
        })
      })
    },

    courseVideoPenHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseVisitRank, { statType: 2, limitNum: 15 }, {
        loading: false,
      }).then((res) => {
        this.courseVideoPen.dataList = res.data
        this.courseVideoPen.MaxArr = this.courseVideoPen.dataList[0]


        for (let i = 0; i < res.data.length; i++) {
          this.courseVideoPen.total += res.data[i].num
        }
      })
    },

    courseVideoSelHandler() {
      this.$axios.post(this.$apiurls.coursePortrait_getCourseStudyRank, { statType: 2, limitNum: 15 }, {
        loading: false,
      }).then((res) => {
        this.courseVideoSel.dataList = res.data
        this.courseVideoSel.MaxArr = this.courseVideoSel.dataList[0]

        this.courseVideoSel.dataList.forEach(item => {
          this.courseVideoSel.total += item.num
        })
      })
    }
  }
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 70%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 34px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 10px;
}
.header_titles span {
  font-size: 20px;
  margin-top: 50px;
}
.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 17px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 20px;
  color: #1d244e;
  font-size: 23px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 20px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 45px;
}
.chart_box p {
  font-size: 20px;
  text-indent: 40px;
  line-height: 45px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}

.biaoge {
  width: 95%;
  /* height: 390px; */
  margin: 0px auto 25px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  color: #707f9d;
  font-size: 15px;
}

.course tr:nth-child(2n) {
  background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: #7ed2ff;
  color: #566178;
}

.course tr:first-child {
  background: #66adff;
  color: #fff;
}

.chart_box {
  width: 100%;
  margin-bottom: 30px;
}

.chart_box h1 {
  font-size: 34px;
  margin-bottom: 50px;
}
.chart_box h2 {
  font-size: 28px;
  margin-bottom: 50px;
}
.chart_box h3 {
  font-size: 22px;
  margin-bottom: 50px;
}
.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  text-indent: 40px;
  line-height: 30px;
}
.chart_box p {
  font-size: 20px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 380px;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
